import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useClipPathId } from "../hooks/use-clip-path-id";

export function ConnectFilled(props) {
  const clipPathId = useClipPathId("connect-filled");
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath={`url(#${clipPathId})`}>
          <path
            d="M20.4706 1H7.29418C5.76476 1 4.58829 2.05882 4.23535 3.35294C4.23535 3.35294 4.23535 3.47059 4.23535 3.58824H16.2354C18.4706 3.58824 20.2354 5.35294 20.2354 7.58824V15.5882C20.2354 15.8235 20.2354 15.9412 20.2354 16.1765C20.353 16.2941 20.4706 16.2941 20.4706 16.4118C22.1177 16.4118 23.5295 15 23.5295 13.2353V4.17647C23.5295 2.41176 22.1177 1 20.4706 1Z"
            fill="currentColor"
          />
          <path
            d="M15.1765 5.70581H3.17647C1.41176 5.70581 0 7.11758 0 8.76463V16.7646C0 18.5293 1.41176 19.9411 3.17647 19.9411H12.1176L11.7647 22.647C12 23.2352 12.7059 23.2352 12.9412 22.647L15.1765 19.9411C16.9412 19.9411 18.3529 18.5293 18.3529 16.7646V8.76463C18.2353 7.11758 16.8235 5.70581 15.1765 5.70581ZM6.70588 13.9411C6.23529 14.294 5.52941 14.1764 5.17647 13.7058C4.82353 13.2352 4.82353 12.5293 5.17647 12.1764C5.64706 11.5882 6.23529 11.4705 6.70588 11.7058C7.17647 11.9411 7.41177 12.294 7.41177 12.7646C7.41177 13.3529 7.17647 13.7058 6.70588 13.9411ZM9.76471 13.8235C9.17647 14.1764 8.47059 14.0588 8.11765 13.5882C7.64706 13.1176 7.64706 12.4117 8.11765 11.9411C8.58824 11.5882 9.29412 11.4705 9.76471 11.7058C10.5882 12.294 10.5882 13.3529 9.76471 13.8235ZM12.7059 13.9411C12.2353 14.294 11.5294 14.1764 11.1765 13.5882C10.8235 13.1176 10.8235 12.5293 11.1765 12.0588C11.6471 11.5882 12.2353 11.4705 12.7059 11.7058C13.1765 11.9411 13.4118 12.294 13.4118 12.7646C13.2941 13.3529 13.1765 13.7058 12.7059 13.9411Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id={clipPathId}>
            <rect
              width="23.5294"
              height={22}
              fill="white"
              transform="translate(0 1)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
